import React from 'react';
import logoMark from '../../../assets/images/nky_connect_logo_only.png';
import { AuthPage, Card, CardFooter, Lead, LogoMark, Title } from './AuthCard.styled';

/**
 * Mint mist page with one white card for short account forms (sign in, password reset, email verification).
 * Form primitives (Field, TextInput, SubmitButton, …) come from AuthCard.styled.js.
 * `badge` (e.g. a StatusBadge) replaces the logo on result screens.
 */
const AuthCard = ({ title, lead, footer, badge, children }) => (
  <AuthPage aria-labelledby="auth-card-title">
    <Card>
      {badge ?? <LogoMark src={logoMark} alt="" aria-hidden />}
      <Title id="auth-card-title">{title}</Title>
      {lead && <Lead>{lead}</Lead>}
      {children}
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  </AuthPage>
);

export default AuthCard;
